var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMilesSpend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28656",
    "data-name": "Group 28656",
    transform: "translate(-1988 -3114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38012",
    "data-name": "Path 38012",
    d: "M628.079,472.079a28,28,0,1,0,28,28A28,28,0,0,0,628.079,472.079Z",
    transform: "translate(1387.921 2641.921)",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-shopping-bag",
    "data-name": "Icon feather-shopping-bag",
    transform: "translate(2001.5 3127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38013",
    "data-name": "Path 38013",
    d: "M4.5,9V25.258a2.323,2.323,0,0,0,2.323,2.323H23.081A2.323,2.323,0,0,0,25.4,25.258V9Z",
    transform: "translate(0 -1.581)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38014",
    "data-name": "Path 38014",
    d: "M4.5,9H25.4",
    transform: "translate(0 -1.581)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38015",
    "data-name": "Path 38015",
    d: "M21.29,15A4.645,4.645,0,0,1,12,15",
    transform: "translate(-1.694 -2.935)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38016",
    "data-name": "Path 38016",
    d: "M21.29,19.645a4.645,4.645,0,1,0-9.29,0",
    transform: "translate(-1.694 -13)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilesSpend);
export default __webpack_public_path__ + "static/media/miles-spend.8671d4e2cee3a893e7d3a7f6ae82885b.svg";
export { ForwardRef as ReactComponent };